import React from 'react';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import TierIcon from '@wix/da-ds/pkg/Icons/16x16/Tier';
import useDeviationStats from './useDeviationStats';
import Stat from './Stat';
const SubscriberStat = ({ deviation, onlyNumbers, className })=>{
    const { subscribers, isSubscribable, isInSubscription } = useDeviationStats(deviation);
    const isTierRelated = isSubscribable || isInSubscription;
    const isShown = isTierRelated && !!subscribers;
    return isShown ? /*#__PURE__*/ React.createElement(Stat, {
        className: className,
        deviation: deviation,
        icon: TierIcon,
        statNameLocaleKey: "deviation.stats.subscribers",
        statCount: subscribers,
        onlyNumbers: onlyNumbers,
        biData: BiData({
            evid: 2,
            click_info: 'subscribers',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        })
    }) : null;
};
SubscriberStat.displayName = 'ViewStat';
export default SubscriberStat;

//# sourceMappingURL=SubscriberStat.js.map